module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('modal', {
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('project.remove.header')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.success),
      expression: "!success"
    }]
  }, [_vm._v(_vm._s(_vm.$t('project.remove.areYouSure')))]), _vm._v(" "), _c('alert', {
    staticClass: "mt-10 mb-0",
    attrs: {
      "success": _vm.success
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeProject
    }
  }, [_vm._v(_vm._s(_vm.$t('remove')))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9956068"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Remove.vue
// module id = 838
// module chunks = 1